import declare from "dojo/_base/declare";
import Action from "csi/def/Action";
import { localStore } from "csi/state/rootStore";
import ToggleButton from "dijit/form/ToggleButton";
import { runInAction } from "mobx";
import locale from "csi/locale";
import { cnl } from "csi/typings";
import { Context } from "csi/def/Context";

const FLAT_INGREDIENT_TOGGLE_NAME = "FlatIngredientToggle";

const FlatIngredientsToggleButton = declare(Action, {
	/**
	 * @override
	 * Add toggle button to bottom of global ingredients view
	 */
	toHtmlControl(ctx: Context, refNode: HTMLElement, bToggled: boolean, bTurntable: boolean) {
		const toggleButton = new ToggleButton({
			showLabel: true,
			class: "csi-button-switch",
			label: locale.resource(FLAT_INGREDIENT_TOGGLE_NAME),
			checked: this.isToggledInitially(ctx),
			onChange: (value: string): void => {
				const nodeURL = ctx.getContextNode().$URL;
				this.setToggleStatusStore(value as unknown as boolean, nodeURL);
				this.inherited(arguments);
			},
		});

		toggleButton.placeAt(refNode);
		toggleButton.startup();
		return toggleButton.domNode;
	},

	/**
	 * Check if button should be toggled when page is loaded
	 * @param ctx - Context
	 * @returns true if button should initialize in toggled state after refresh
	 */
	isToggledInitially(ctx: Context) {
		const dataSheetURL = ctx.getContextNode().$URL;
		return localStore.formulatedProduct.lastToggleStates.get(dataSheetURL);
	},

	/**
	 * 
	 * @param status - the toggled state of the toggle button
	 * @param sheetURL - URL of the current FLDS
	 */
	setToggleStatusStore(status: boolean, sheetURL: cnl) {
		runInAction(() => {
			localStore.formulatedProduct.lastToggleStates.set(sheetURL, status);
		});
	},
});

export = FlatIngredientsToggleButton;